let events = new Map();
let es = null;
let log = false;
let lastActivity = 0;
let timerCheckActivity = null;
const MAX_SILENCE = 70000;
export let isConnected = false;
let currentUrl = null;
let manuallyClosed = false;

export function Connect(url) {
    currentUrl = url;
    manuallyClosed = false;

    if (es) {
        es.close();
        es = null;
    }

    if (timerCheckActivity) {
        clearInterval(timerCheckActivity);
        timerCheckActivity = null;
    }

    lastActivity = Date.now();

    if (log) console.log('> connect to url ' + url);

    es = new EventSource(url);

    es.addEventListener('event', (e) => {
        lastActivity = Date.now();

        try {
            const payload = JSON.parse(e.data);
            if (log) console.log('EMIT EVENT:', payload);

            if (payload.event === 'connected') {
                isConnected = true;
            }

            Trigger(payload.event, payload.data);
        } catch (err) {
            console.error('Invalid SSE payload', err, e.data);
        }
    });

    es.addEventListener('heartbeat', () => {
        lastActivity = Date.now();
    });

    es.onopen = () => {
        lastActivity = Date.now();
        isConnected = true;
        if (log) console.log('sse open');
        //Trigger('connected');
    };

    es.onmessage = () => {
        lastActivity = Date.now();
    };

    es.onerror = () => {
        if (log) console.log('sse error, readyState:', es ? es.readyState : 'null');

        isConnected = false;
        Trigger('disconnected');
    };

    timerCheckActivity = setInterval(() => {
        if (!es) return;

        if (Date.now() - lastActivity > MAX_SILENCE) {
            console.warn('SSE stuck, forcing reconnect');

            const reconnectUrl = currentUrl;
            Disconnect(false);
            Connect(reconnectUrl);
        }
    }, 5000);
}

export function Disconnect(triggerEvent = true) {
    manuallyClosed = true;

    if (es) {
        es.close();
        es = null;
    }

    isConnected = false;

    if (timerCheckActivity) {
        clearInterval(timerCheckActivity);
        timerCheckActivity = null;
    }

    if (triggerEvent) {
        Trigger('disconnected');
    }
}

export function Trigger(event, data) {
    console.log(data);
    if (events.has(event)) {
        events.get(event).forEach((value) => {
            value(data);
        });
    }
}

export function On(event, func) {
    if (!events.has(event)) events.set(event, new Map());
    events.get(event).set(func, func);
    LogStatus();
}

export function Off(event, func) {
    if (events.has(event) && events.get(event).has(func)) {
        events.get(event).delete(func);
    }
    LogStatus();
}

export function LogStatus() {
    if (!log) return;

    console.log('===== SSE EVENTS STATUS =====');
    events.forEach((value, key) => {
        console.log(`> ${key} => ${value.size}`);
    });
}